'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _lib = require('helpers/lib');

var _thumbnail = require('assets/img/home/thumbnail.png');

var _thumbnail2 = _interopRequireDefault(_thumbnail);

var _reactRedux = require('react-redux');

var _setup = require('redux/modules/setup');

var setupActions = _interopRequireWildcard(_setup);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HelmetSEO = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    seos: state.setup.seos
  };
}, (0, _extends3.default)({}, setupActions)), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(HelmetSEO, _Component);

  function HelmetSEO() {
    (0, _classCallCheck3.default)(this, HelmetSEO);
    return (0, _possibleConstructorReturn3.default)(this, (HelmetSEO.__proto__ || (0, _getPrototypeOf2.default)(HelmetSEO)).apply(this, arguments));
  }

  (0, _createClass3.default)(HelmetSEO, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          path = _props.path,
          seos = _props.seos,
          seoProps = _props.seoProps,
          shopSeo = _props.shopSeo;

      var meta = [];
      var url = location ? _config2.default.siteUrl + location.pathname : '';
      var imageSeo = void 0,
          title = void 0,
          description = void 0;
      var seoData = void 0;
      if (path) {
        seoData = seos && seos[path] ? seos[path] : '';
      } else {
        seoData = seoProps ? seoProps : '';
      }
      if (shopSeo) {
        imageSeo = shopSeo ? (0, _lib.getUrlImage)(shopSeo.image) : _thumbnail2.default;
        imageSeo = shopSeo && shopSeo.image ? (0, _lib.getUrlImage)(shopSeo.image) : (0, _lib.getUrlImage)(imageSeo);
        title = shopSeo && shopSeo.name ? shopSeo.name + ' - b\u1EA3ng gi\xE1 d\u1ECBch v\u1EE5, review, \u0111\u1EB7t l\u1ECBch - Lookme.vn' : '';
        description = shopSeo && shopSeo.name && shopSeo.address ? 'Xem th\xF4ng tin, review, b\u1EA3ng gi\xE1 d\u1ECBch v\u1EE5, v\xE0 \u0111\u1EB7t l\u1ECBch t\u1EA1i ' + shopSeo.name + ' \u0111\u1ECBa ch\u1EC9 ' + shopSeo.address + '. L\u1EA5y voucher \u01B0u \u0111\xE3i t\u1EA1i Lookme.vn. \u0110\u1EB7t l\u1ECBch, t\xEDch \u0111i\u1EC3m \u0111\u1ED5i voucher h\u01A1n 7000 \u0111\u1ECBa \u0111i\u1EC3m' : '';
      } else {
        imageSeo = seoData ? (0, _lib.getUrlImage)(seoData.image) : _thumbnail2.default;
        imageSeo = seoData && seoData.image ? (0, _lib.getUrlImage)(seoData.image) : (0, _lib.getUrlImage)(imageSeo);
        title = seoData && seoData.name ? seoData.name : '';
        title = seoData && seoData.title ? seoData.title : title;
        description = seoData && seoData.description ? (0, _lib.stripHtmlTags)(seoData.description) : '';
      }
      if (imageSeo) {
        meta.push({ property: 'og:image', content: imageSeo });
      }
      if (url) {
        meta.push({ property: 'og:url', content: url });
      }
      if (title) {
        meta.push({ property: 'og:title', content: title });
      }
      if (description) {
        meta.push({
          name: 'description',
          property: 'og:description',
          content: description
        });
        meta.push({ name: 'description', content: description });
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactHelmet2.default, _config2.default.app.head),
        _react2.default.createElement(_reactHelmet2.default, { title: title, meta: meta })
      );
    }
  }]);
  return HelmetSEO;
}(_react.Component), _class2.propTypes = {
  seos: _react.PropTypes.object,
  seoProps: _react.PropTypes.object,
  shopSeo: _react.PropTypes.object,
  location: _react.PropTypes.object,
  path: _react.PropTypes.string
}, _temp)) || _class);
exports.default = HelmetSEO;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Helmet/HelmetSEO.js
// module id = 1522
// module chunks = 0